var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-div"},[_c('div',{staticClass:"main-loader-div"},[_c('img',{staticClass:"loader-image",attrs:{"src":require("@/assets/loader.svg"),"alt":"loader"}})]),_vm._v(" "),_c('p',{staticClass:"loading"},[_vm._v(" Please wait a moment")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38888b23","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Loader.vue
// module id = 204
// module chunks = 309